import { glideCarouselInfiniteBulletConfig } from "../library/glide";
import handleMediaQueryChange from "../utilities/helpers/_media_query";

const snNowMobile = () => {
    const snNowPlugins = document.querySelectorAll("[data-sn-now] .glide");

    if (snNowPlugins.length === 0) return;

    snNowPlugins.forEach((plugin) => {
        glideCarouselInfiniteBulletConfig(plugin, {
            type: "carousel",
            perView: 1,
            focusAt: 0,
            startAt: 0,
            swipeThreshold: true,
            dragThreshold: true,
            gap: 12,
        });
    });
};

const snNowSlider = () => {
    handleMediaQueryChange(snNowMobile, null);
};

const initializeSnNow = () => {
    snNowSlider();
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeSnNow);
} else {
    initializeSnNow();
}

export { snNowSlider };
